import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { FieldModal, DocumentGroupNewModal } from '../../../modals';
import { FormBuilderService } from '../../../services';

@Component({
	selector: 'app-procurement-detail',
	templateUrl: './procurement-detail.component.html',
	styleUrls: [ './procurement-detail.component.scss' ]
})
export class ProcurementDetailComponent implements OnInit {
	pending: boolean;
	success: any;
	error: any;
	fieldArrays: Array<any> = [];
	constructor(
		private location: Location,
		private modalService: SuiModalService,
		private formBuilder: FormBuilderService
	) {}
	goBack() {
		this.location.back();
	}

	editProcurement() {
		this.modalService
			.open(new DocumentGroupNewModal('Edit Document Group', '', true, ModalSize.Tiny))
			.onApprove((eq) => {
				// this.selectedCertificateHolder = eq;
				// this.startApplication(eq);
			})
			.onDeny(() => console.log('add certificate holder cancel'));
	}

	delete() {
		this.modalService
			.open(
				new ConfirmModal(
					'Delete Document Group?',
					'Are you sure you want to delete this procurement cycle?',
					ModalSize.Tiny
				)
			)
			.onApprove(() => {})
			.onDeny(() => {});
	}

	ngOnInit(): void {}
}
